import { ReactComponent as HeadySolid } from 'assets/icons/heady-solid.svg';

export default HeadySolid;
